import React from "react"

import { ChildSelector } from "../helpers/ChildSelector"

import * as twoColumnSectionStyles from "../styles/TwoColumnSection.module.css"

export default function ThreeColumnSection(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `two-column-title`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const textStack = ChildSelector.select(
    content,
    `two-column-content`,
    ChildSelector.SELECTOR_TYPE.ARRAY
  )

  return (
    <>
      <div
        className={`row ${twoColumnSectionStyles.wrapper} ${props.className}`}
      >
        <div className={`col-12 col-md-5 ${twoColumnSectionStyles.holder}`}>
          <h2 className={`${twoColumnSectionStyles.title}`}>{title}</h2>
        </div>
        <div className={`col-12 col-md-6 ${twoColumnSectionStyles.textHolder}`}>
          {textStack.map((c, idx) => (
            <p key={idx} className={`${twoColumnSectionStyles.content}`}>
              {!c.classNames
                .trim()
                .split(/\s+/)
                .includes(`two-column-content-list`) && c.innerHTML}
              {c.classNames
                .trim()
                .split(/\s+/)
                .includes(`two-column-content-list`) && (
                <ul>
                  {c.childNodes &&
                    c.childNodes.map((i, indx) => (
                      <li key={indx}>{i.innerHTML}</li>
                    ))}
                </ul>
              )}
            </p>
          ))}
        </div>
      </div>
    </>
  )
}
